const education = [
    {
        name: "university-of-texas-austin",
        title: "University of Texas at Austin",
        degree: "Full Stack Web Development Certificate",
        location: "Austin, TX",
        url: 'https://extendedcampus.utexas.edu/',
        featured: true
    },
    {
        name: "university-of-houston",
        title: "University of Houston",
        degree: "Bachelor of Science in Human Nutrition",
        location: "Houston, TX",
        url: 'https://www.uh.edu/',
        featured: true
    },
    {
        name: "portland-state-university",
        title: "Portland State University",
        degree: "Graduate Certificate in Geographic Information Systems",
        location: "Portland, OR",
        url: 'https://www.pdx.edu/',
        featured: true
    },
    {
        name: "washington-state-university",
        title: "Washington State University",
        degree: "Bachelor of Arts in Social Science",
        location: "Vancouver, WA",
        url: 'https://www.vancouver.wsu.edu/',
        featured: true
    }
];

export default education;